import React from "react";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import IconMenu from "../../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Fab from "@mui/material/Fab";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import OrderDetail from "./OrderDetail";
import CompleteOrder from "../../Packing/CompleteOrder";
import useSave from "../../../Hooks/useSave";
import canView from "../../../Hooks/useProtectView";

const menuHeader = {
  icon: <AssignmentIcon sx={{ color: "white" }} fontSize="small" />,
  name: "Order",
};

const menu = [
  { link: "order", name: "Order" },
  { link: "packing-slip", name: "Packing Slip" },
  { link: "invoice", name: "Invoice" },
];

export default function Order() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { fetchGraphql } = useSave();
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "row",
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <IconMenu menuHeader={menuHeader} menu={menu} />

        {canView("admin") && (
          <Button
            sx={{ marginTop: "20px" }}
            variant="contained"
            onClick={() => {
              fetchGraphql({
                query: `mutation UpdateOrder($orderId: ID!, $order: orderInput) {
                updateOrder(orderId: $orderId, order: $order) {
                  orderId
                }
              }`,
                variables: { orderId: id, order: { orderStatus: "Submited" } },
              }).then((result) => navigate(`/orders/new-order-customer/${id}`));
            }}
          >
            Move to submited
          </Button>
        )}
      </Box>

      <Paper
        sx={{
          width: "100%",
          marginLeft: "20px",
          padding: "20px",
        }}
      >
        <Routes>
          <Route path="/order" element={<OrderDetail />} />{" "}
          <Route path="/packing-slip" element={<CompleteOrder />} />
          <Route
            path="/products"
            element={
              <>
                <Fab
                  color="secondary"
                  sx={{ position: "absolute", bottom: 35, right: 35 }}
                >
                  <EditIcon />
                </Fab>
                <Fab
                  color="primary"
                  sx={{ position: "absolute", bottom: 35, right: 100 }}
                >
                  <PrintIcon />
                </Fab>
                <Fab
                  color="warning"
                  sx={{ position: "absolute", bottom: 35, right: 165 }}
                >
                  <SaveAltIcon />
                </Fab>
              </>
            }
          />
        </Routes>
      </Paper>
    </Box>
  );
}
